import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get colour
export const getColour = createAsyncThunk("colour/getColour", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getColour({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all colour
export const getAllColour = createAsyncThunk("colour/getAllColour", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllColour();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("colour/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("colour/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("colour/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage } = params;
  try {
    const { data } = await API.getPageColour(number, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create colour
export const createColour = createAsyncThunk("colour/createColour", async (params, { rejectWithValue }) => {
  const { name, isActive } = params;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.createColour(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateColour = createAsyncThunk("colour/updateColour", async (params, { rejectWithValue }) => {
  const { id, values } = params;
  const { name, isActive } = values;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.updateColour(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("colour/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
